<template>
  <div class="clientsAdd">
    <div class="pageContent">
      <heading type="h1">Add User</heading>
      <spinner v-if="loading" />
      <user-form :submit="add" :isAddUser="true" :user="userNew" @loading="onLoadingStatus" />
    </div>
  </div>
</template>

<script>
import Heading from '@/components/Heading/heading'
import ButtonCta from '@/components/Button/button'
import Spinner from '@/components/SpinnerIcon/spinner'
import UserForm from '@/components/UserForm/user-form'
import {userMixin} from '@/mixins/userMixin'
import {pageMixin} from '@/mixins/pageMixin'
import {notificationMixin} from '@/mixins/notificationMixin'

export default {
  name: 'UsersAdd',
  mixins: [userMixin, notificationMixin, pageMixin],
  components: {
    Heading,
    ButtonCta,
    Spinner,
    UserForm
  },
  data: () => ({
    loading: false,
    userNew: {
      currency: 'gbp'
    }
  }),
  methods: {
    add () {
      this.loading = true
      this.userNew.locale = 'en_gb' // TO DO: remove this when server changes locale to optional
      this.addUser(this.userNew).then(() => {
        this.loading = false
        this.addNotification('success', 'New user added. They should receive an email with instructions on how to get started.')
        this.$router.push({path: '/users'})
      }, error => {
        this.loading = false
        this.addNotification('danger', error)
      })
    }
  }
}
</script>

<style lang="scss">
    .usersAdd {
    }
</style>



// WEBPACK FOOTER //
// src/pages/user/users-add.vue